export default __webpack_public_path__ + "static/media/bgEight.88b405bd.jpg";